import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {Configuration} from './configuration';

import {ApiMonitorService} from './api/apiMonitor.service';
import {BwEtreeService} from './api/bw-etree.service';
import {BwGraphDataService} from './api/bwGraphData.service';
import {BwImportDataService} from './api/bwImportData.service';
import {BwScheduleService} from './api/bw-schedule.service';

import {LoaService} from './api/loa.service';
import {LoaContactService} from './api/loa-contact.service';
import {FormattedGraphDataService} from './api/formattedGraphData.service';
import {MailItemService} from './api/mailItem.service';
import {MailItemAttachmentService} from './api/mailItemAttachment.service';

import {SwiftMailerLogService} from './api/swiftMailerLog.service';
import {UpdateRequestService} from './api/updateRequest.service';
import {UserService} from './api/user.service';
import {BwGraphsVvlansService} from './api/bwGraphsVvlans.service';
import {BwGraphsUserConfigsService} from './api/bwGraphsUserConfigs.service';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  declarations: [],
  exports: [],
  providers: [
    ApiMonitorService,
    BwEtreeService,
    BwGraphDataService,
    BwImportDataService,
    BwScheduleService,
    LoaService,
    LoaContactService,
    FormattedGraphDataService,
    MailItemService,
    MailItemAttachmentService,
    SwiftMailerLogService,
    UpdateRequestService,
    UserService,
    BwGraphsVvlansService,
    BwGraphsUserConfigsService
  ]
})
export class ApiModule {
  public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [{provide: Configuration, useFactory: configurationFactory}]
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ApiModule) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import your base AppModule only.');
    }
  }
}
